import React, {PureComponent} from 'react';
import {Input, Button, Form} from 'antd';
import {injectIntl, FormattedMessage} from 'react-intl';
import {ADMIN_USER_ID, USER_FROM} from "../../utils/constants";

const FormItem = Form.Item;

class ChangePwd extends PureComponent {
  render() {
    const {intl, form, userInfo} = this.props;
    const {getFieldDecorator} = form;
    const {userFrom} = userInfo;
    if (userFrom !== USER_FROM.local) {
      return null;
    }
    return <div>
      <div className="card-title">
        <FormattedMessage id="reset_password"/>
      </div>
      <div className="setting-info">
        <Form onSubmit={this.submitPwd}>
          <FormItem
            label={intl.formatMessage({id: 'old_password'})}
          >
            {getFieldDecorator('oldPwd', {
              rules: [{
                required: true, message: intl.formatMessage({id: 'old_password_notNull'})
              }],
            })(
              <Input type="password" placeholder={intl.formatMessage({id: 'old_password'})}/>
            )}
          </FormItem>
          <FormItem
            label={intl.formatMessage({id: "new_password"})}
          >
            {getFieldDecorator('newPwd', {
              rules: [{
                required: true, message: intl.formatMessage({id: "new_password_notNull"})
              }, {
                validator: this.checkNewPwd
              }],
              validateFirst: true,
            })(
              <Input type="password" placeholder={intl.formatMessage({id: "new_password_tip"})}/>
            )}
          </FormItem>
          <FormItem
            label={intl.formatMessage({id: "sure_password"})}
          >
            {getFieldDecorator('confirmPwd', {
              rules: [{
                required: true, message: intl.formatMessage({id: "sure_password_notNull"})
              }, {
                validator: this.checkConfirmPwd
              }],
              validateFirst: true,
            })(
              <Input type="password" placeholder={intl.formatMessage({id: "new_password_tip"})}/>
            )}
          </FormItem>
          <Button type="primary" htmlType="submit">
            <FormattedMessage id="btn_save"/>
          </Button>
        </Form>
      </div>
    </div>;
  }

  checkNewPwd = (rule, value, callback) => {
    const form = this.props.form;
    value = value ? value.trim() : "";
    const test1 = /^.*[a-zA-Z]+.*$/;
    const test2 = /^.*\d+.*$/;
    if (!test1.test(value) || !test2.test(value) || value.length < 8) {
      callback(this.props.intl.formatMessage({id: 'new_pwd_check_err'}));
    } else {
      if (form.getFieldValue('confirmPwd')) {
        this.props.form.validateFields(['confirmPwd'], {force: true});
      }
      callback();
    }
  };

  checkConfirmPwd = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('newPwd')) {
      callback(this.props.intl.formatMessage({id: 'sure_pwd_notEq'}));
    } else {
      callback();
    }
  };

  submitPwd = e => {
    e.preventDefault();
    const {form, dispatch} = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        dispatch({type: 'personal/modifyPwd', pwdInfo: values});
      }
    });
  };
}

export default Form.create()(injectIntl(ChangePwd));



// WEBPACK FOOTER //
// ./src/routes/Personal/ChangePwd.js